"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getModelState = void 0;
/**
 * Gets an instance of IModelState and adds any matching server side errors to the vee-validate form.
 * See https://vee-validate.logaretm.com/v4/guide/components/handling-forms#setting-errors-manually
 * @param validationErrors server side validation errors
 * @param formActions vee-validate FormActions
 * @returns an instance of IModelState
 */
function getModelState(validationErrors, formActions) {
    var modelErrors = [];
    var propertyErrors = {};
    Object.getOwnPropertyNames(validationErrors).forEach(function (prop) {
        var errors = validationErrors[prop];
        if (prop === "") {
            errors.forEach(function (error) { return modelErrors.push(error); });
        }
        else {
            // Sometimes the property names are PascalCased
            var propertyName = camelCase(prop);
            propertyErrors[propertyName] = errors;
            formActions.setFieldError(propertyName, errors);
        }
    });
    return { modelErrors: modelErrors, propertyErrors: propertyErrors };
}
exports.getModelState = getModelState;
function camelCase(value) {
    return (value
        // split by dots
        .split(".")
        // convert PascalCase to camelCase
        .map(function (part) {
        return part.substring(0, 1).toLowerCase() +
            part.substring(1, part.length);
    })
        // join back together by dot
        .join("."));
}
//# sourceMappingURL=getModelState.js.map